/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
/* eslint-disable no-use-before-define */
/* eslint-disable no-var */
/* eslint-disable vars-on-top */
import $ from 'jquery';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { getToken } from '../../utils/login';
import showAlert from '../../utils/showAlert';
import _t from '../../utils/translate';

const getContents = ({ contents, formationId, currentPrice }) => (
  {
    domain: {
      chainId: window.selectedChain === 'CHZ' ? window.signatureChainIdChz : window.signatureChainId,
      name: 'NftSoccerGames',
      verifyingContract: window.selectedChain === 'CHZ' ? window.contractAddressChz : window.contractAddress,
      version: '1',
    },

    // Defining the message signing data content.
    message: {
      contents,
      formationId,
      price: currentPrice,
    },
    // Refers to the keys of the *types* object below.
    primaryType: 'FormationBuy',
    types: {
      EIP712Domain: [
        { name: 'name', type: 'string' },
        { name: 'version', type: 'string' },
        { name: 'chainId', type: 'uint256' },
        { name: 'verifyingContract', type: 'address' },
      ],
      FormationBuy: [
        { name: 'formationId', type: 'uint256' },
        { name: 'price', type: 'uint256' },
      ],
    },
  }
);

const initBuyFormation = async () => {
  $(document).on('click', '.formationClaim', async (e) => {
    const target = $(e.currentTarget);
    const formationId = target.data('id');
    const currentPrice = target.data('price');
    const formation = target.data('formation');
    const positions = target.data('positions');

    Swal.fire({
      title: 'Buy Formation',
      html: `
        <div class="text-center" style="margin-top: 30px; position: relative;">
          <div class="" style="text-shadow: 1px 1px 1px #000; font-size: 20px;">
            Formation: <span style="color: red;font-weight: bold;">${formation}</span>
            <br /> Positions: <span style="color: red;font-weight: bold;">${positions}</span>
            <br /> Price: <span style="color: red;font-weight: bold;">${currentPrice} $NFSG</span>
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: _t('Buy!'),
      showLoaderOnConfirm: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        showAlert({
          title: 'In Progress',
          message: 'Please wait while your transaction is in progress. You will be redirected to My Wallet page when the transaction succeeds.',
          icon: 'wait',
        });
        const token = getToken();
        $.post('/api/team/claimFormation', {
          token,
          formationId,
        }, (data) => {
          if (data.success) {
            Swal.fire(
              _t('Success!'),
              data.message,
              'success',
            );
            window.location = '/my-team';
          } else {
            Swal.fire(
              _t('Error!'),
              data.message,
              'error',
            );
          }
        });
      }
    });
  });
};

export default initBuyFormation;
